import { ALL_HUB_ID } from 'features/MultiCategory/constant/homeTabCreateEdit'
import { ALL_HUB_VALUE } from './LocationHubs'

/** "Semua Hub" travels as `[0]`; an empty list means no hub was picked. */
export const toLocationIds = (hubs: string[]) =>
  hubs.includes(ALL_HUB_VALUE) ? [ALL_HUB_ID] : hubs.map(Number).filter(Boolean)

/** A stored `[0]` is the picker's "Semua Hub" option; an empty list stays unpicked. */
export const toFormHubs = (locationIds: number[]) =>
  locationIds.includes(ALL_HUB_ID) ? [ALL_HUB_VALUE] : locationIds.map(String)
